<template>
  <main class="reset-pwd-email">
    <div class="email-wrap tc">
      <p class="desc">A reset password Email has been sent to you</p>
      <p>Please check your inbox for an email</p>
      <p class="link-btn" @click="handleSendemial">resend email</p>
    </div>
  </main>
</template>

<script>
  import adminService from '../service/adminService';
  import toast from "../../common/utils/toast";
  import loading from "../../common/utils/loading";
export default {
  name: "reset-pwd-email",

  methods: {
    handleSendemial(){
      loading.show();
      adminService.resetEmail()
          .then((res)=>{
            loading.hide();
            if(res){
              console.log(res);
              toast.show({
                content: 'success',
                stayTime: 2000,
                withMask: false
              })
            }
          },(error)=>{
            loading.hide();
            console.log(error);
            toast.show({
              content: 'fail',
              stayTime: 2000,
              withMask: false
            })
          })
    }
  }
}
</script>
